import http from "../http";
import { CustomAxiosError } from "../../helpers/customErrors";

export default {
  // Whose address this is, and who (if anyone) is signed in at it.
  async sessionApi() {
    try {
      const response = await http().get("auth/session");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async adminLoginApi(data) {
    try {
      const response = await http().post("admin/auth/login", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantLoginApi(data) {
    try {
      const response = await http().post("tenant/auth/login", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async adminProfileApi() {
    try {
      const response = await http().get("admin/auth/profile");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantProfileApi() {
    try {
      const response = await http().get("tenant/auth/profile");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async adminLogoutApi() {
    try {
      const response = await http().post("admin/auth/logout");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantLogoutApi() {
    try {
      const response = await http().post("tenant/auth/logout");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async acceptInviteApi(data) {
    try {
      const response = await http().post("tenant/invite/accept", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
  async adminAcceptInviteApi(data) {
    try {
      const response = await http().post("admin/invite/accept", data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
  async adminHeartbeatApi() {
    try {
      const response = await http().get("admin/auth/heartbeat");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async tenantHeartbeatApi() {
    try {
      const response = await http().get("tenant/auth/heartbeat");
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  /*
   * Forgotten passwords: a reset link by email, then a new password. `scope`
   * is the address's ("admin" on the admin console, "tenant" at a company).
   */
  async forgotPasswordApi(scope, data) {
    try {
      const response = await http().post(`${scope === "admin" ? "admin" : "tenant"}/auth/password/forgot`, data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async checkResetLinkApi(scope, data) {
    try {
      const response = await http().post(`${scope === "admin" ? "admin" : "tenant"}/auth/password/reset/check`, data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  async resetPasswordApi(scope, data) {
    try {
      const response = await http().post(`${scope === "admin" ? "admin" : "tenant"}/auth/password/reset`, data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
  /*
   * Google Authenticator: the code step of signing in. `step` is "setup",
   * "confirm" or "challenge"; each call carries the ticket the password gave.
   */
  async twoFactorApi(scope, step, data) {
    try {
      const response = await http().post(`${scope === "admin" ? "admin" : "tenant"}/auth/two-factor/${step}`, data);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },

  // Lost phone: the person sets it up again at their next sign-in.
  async resetTwoFactorApi(scope, id) {
    try {
      const path = scope === "admin" ? `admin/admins/${id}/two-factor/reset` : `tenant/employees/${id}/two-factor/reset`;
      const response = await http().post(path);
      return response.data;
    } catch (error) {
      throw new CustomAxiosError(error.response?.data || error.message);
    }
  },
};
